//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams,countDownTimeFunc} from '@/utils/util.js'
import footerNav from '@/components/footerNav'
import { Dialog,Toast } from 'vant';

export default {
  name: "importOrder",
  components: {
    footerNav
  },
  data() {
    return {
      value:''
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    onSearch(){
    },
    toDetail(){
      this.$router.push({name:'importOrderDetail'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/importOrder/index.vue